var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isNavMenuOpen)?_c('img',{staticClass:"no-b",attrs:{"src":require("../assets/img/menu-open.png")},on:{"click":_vm.toggleMenuOpen}}):_c('img',{staticClass:"no-b",attrs:{"src":require("../assets/img/menu-close.png")},on:{"click":_vm.toggleMenuOpen}}),_c('span',{staticClass:"panelStyle",on:{"click":_vm.toPanel}},[_vm._v("系统看板")])])
}
var staticRenderFns = []

export { render, staticRenderFns }